/**
 * Copyright (c) 2021 TechDivision GmbH
 * All rights reserved
 */
;(function () {
    /**
     * @constructor
     */
    function LiveSupportApi() {
        /**
         * @private
         */
        const _this = this

        /**
         */
        this.buttonClass = '.js-support'

        /**
         */
        this.apiUrl = 'https://al5-app11.adiacom.live/serviceinfo/esb'

        /**
         * initialize liveSupportApi
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.fetchData()
        }

        /**
         * Fetch adiacom.live and handle response
         *
         * @method fetchData
         * @returns {undefined}
         */
        this.fetchData = function () {
            fetch(_this.apiUrl, {
                method: 'GET',
            })
                .then(function (res) {
                    return res.json()
                })
                .then(function (json) {
                    if (_this.adviserAvailable(json)) {
                        _this.toggleVisibilityClass(true)
                    } else {
                        _this.toggleVisibilityClass(false)
                    }
                })
                .catch(function (err) {
                    _this.toggleVisibilityClass(false)
                })
        }

        /**
         * Handle visibility of all support buttons
         *
         * @method toggleVisibilityClass
         * @param show
         * @returns {undefined}
         */
        this.toggleVisibilityClass = function (show) {
            let buttons = document.querySelectorAll(_this.buttonClass)
            buttons.forEach(function (button) {
                if (show) {
                    button.classList.remove('hidden')
                } else {
                    button.classList.add('hidden')
                }
            })
        }

        /**
         * Check if a adviser is available
         *
         * @method adviserAvailable
         * @param result
         * @returns {boolean}
         */
        this.adviserAvailable = function (result) {
            return result.serviceState.all && result.serviceState.all[3] > 0
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Energy) {
        window.Energy = {}
    }

    window.Energy.LiveSupportApi = LiveSupportApi
})()

if (document.readyState !== 'loading') {
    let liveSupportButtons = document.querySelectorAll('.js-support')
    if (liveSupportButtons.length) {
        new window.Energy.LiveSupportApi()
    }
} else {
    document.addEventListener('DOMContentLoaded', function () {
        let liveSupportButtons = document.querySelectorAll('.js-support')
        if (liveSupportButtons.length) {
            new window.Energy.LiveSupportApi()
        }
    })
}
